<template>
  <div class="pa-5">
    <v-form ref="newsForm" lazy-validation v-on:submit.prevent="submit">
      <div class="form-group">
        <croppa accept=".jpeg,.jpg,.png" @file-type-mismatch="onFileTypeMismatch" :prevent-white-space="true"
          v-model="myCroppa" :width="400" :height="400" :placeholder="
            $t('Lisää kuva klikkaamalla tai raahaamalla kuva tähän')
          " :placeholder-font-size="12" :initial-image="currentImage" @image-remove="removeImage"
          @new-image-drawn="imageLoaded"></croppa>
      </div>
      <v-btn color="primary" @click="save">{{ $t("Tallenna") }}</v-btn>
    </v-form>
  </div>
</template>

<script>
import api from "@/api";
import "vue-croppa/dist/vue-croppa.css";

export default {
  props: ["width", "height", "currentImage"],
  data() {
    return {
      myCroppa: {},
      myCroppaInitialMedadata: {
        startX: 0,
        startY: 0,
        scale: 1,
        orientation: 1,
      },
      imageRemoved: false,
      imageLoadded: false,
    };
  },
  methods: {
    onFileTypeMismatch(file) {
      alert(
        t(
          "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomuotoja ovat jpeg sekä png."
        )
      );
    },
    imageLoaded() {
      this.imageRemoved = false;
      this.imageLoadded = true;
    },
    removeImage() {
      this.imageRemoved = true;
    },
    async save() {
      const formData = new FormData();
      if (this.imageLoadded && !this.imageRemoved) {
        let imageName = this.myCroppa.chosenFile.name;
        let imageBlob = null;

        // If changed or modified
        if (this.myCroppa.chosenFile) {
          //if (this.myCroppa.chosenFile != null) {
          imageBlob = await this.myCroppa.promisedBlob(
            this.myCroppa.chosenFile.type,
            0.8
          );
        } else {
          const metadata = this.myCroppa.getMetadata();
          if (
            (metadata.startX != 0 ||
              metadata.startY != 0 ||
              metadata.orientation != 1,
              metadata.scale != 1)
          ) {
            imageBlob = await this.myCroppa.promisedBlob("", "1");
          }
        }

        if (imageBlob) {
          let response = await api.updateProfileImage(
            imageBlob,
            imageName
          );
          this.$emit("updated", response.data);
        }
      } else if (this.imageRemoved) {
        const response = await api.removeProfileImage();
        this.$emit("updated", response.data);
      }
    },
  },
};
</script>

<style></style>
